export enum CurrentClientRegularPartnerApiTags {
  List = 'CurrentClientRegularPartnersList',
}

export const currentClientRegularPartnerApiTagTypes = Object.values(CurrentClientRegularPartnerApiTags);
